import { Switch } from '@ads/components-react';
import type { ComponentType, SVGProps } from 'react';

/** Props do SettingTile */
export interface SettingTileProps {
  /** Ícone (Hero Icon) exibido no tile */
  readonly icon: ComponentType<SVGProps<SVGSVGElement>>;
  /** Título da regra */
  readonly label: string;
  /** Estado atual do toggle */
  readonly checked: boolean;
  /** Callback ao alternar o toggle */
  readonly onChange: (checked: boolean) => void;
}

/**
 * Tile de configuração booleana usado na seção "Exibição e regras" do formulário
 * de questão: ícone + título + `Switch`. Substitui os pares de radio sim/não.
 */
export function SettingTile({ icon: Icon, label, checked, onChange }: SettingTileProps) {
  return (
    <div
      className={`flex items-center gap-nano rounded-sm border-hairline border-ctx-layout-border p-micro ${
        checked ? 'bg-ctx-layout-surface' : 'bg-ctx-layout-body'
      }`}
    >
      <div className="flex size-xs shrink-0 items-center justify-center rounded-sm border-hairline border-ctx-layout-border bg-ctx-layout-surface">
        <Icon className="size-mini text-ctx-content-title" />
      </div>
      <span className="flex-1 text-ctx-content-title ts-subtitle-xxs">{label}</span>
      <Switch checked={checked} onCheckedChange={onChange} />
    </div>
  );
}
